export default __webpack_public_path__ + "static/blob11-04c9617b8c2f481d0df9f4f19078bf56.svg";